import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import { SelectedContact } from '../CustomHooks/useContactPickerMultiOrchestrator';
import SelectedContactCard from './SelectedContactCard';
import './SelectedContactsList.scss';

interface SelectedContactsListProps {
  selected: SelectedContact[];
  onRemove: (userId: string) => void;
}

const buildAvatarBadge = (
  role: string
): 'service-provider' | 'property-manager' => {
  if (role === 'Service Provider' || role === 'Service Manager') {
    return 'service-provider';
  }

  return 'property-manager';
};

const SelectedContactsList = ({
  selected,
  onRemove,
}: SelectedContactsListProps) => {
  if (selected.length === 0) {
    return (
      <div className="selected-contacts-list is-empty">
        <div className="selected-contacts-empty">No contacts selected yet.</div>
      </div>
    );
  }

  return (
    <div className="selected-contacts-list">
      {selected.map((contact: SelectedContact) => (
        <div key={contact.userId} className="selected-contacts-row">
          <SelectedContactCard
            name={contact.name}
            role={contact.role}
            profileImage={contact.profileImage}
            badge={buildAvatarBadge(contact.role)}
          />
          <button
            type="button"
            className="selected-contacts-row-clear"
            title="Remove contact"
            aria-label={`Remove ${contact.name}`}
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              onRemove(contact.userId);
            }}
          >
            <FontAwesomeIcon glyph="times" weight="light" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default SelectedContactsList;